import { axiosInstance } from "../../Utils/AxiosInstance";

export const GetAllGatepassApi = async (projectId) => {
  try {
    const url = projectId
      ? `/Store/Gatepass/GetAll?projectId=${projectId}`
      : `/Store/Gatepass/GetAll`;
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetGatepassByIdApi = async (id) => {
  try {
    const response = await axiosInstance.get(`/Store/Gatepass/GetById/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddGatepassApi = async (data) => {
  try {
    const response = await axiosInstance.post(`/Store/Gatepass/Create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
